export default __webpack_public_path__ + "static/media/9、维生素水产品介绍.ef90a58f.jpg";